import api from './axios';

const params = (idEmpresa) => (idEmpresa ? { id_empresa: idEmpresa } : undefined);

export const listProdutos = (incluirInativos) =>
  api.get('/produtos/', { params: incluirInativos ? { incluir_inativos: true } : undefined });
export const createProduto = (data, idEmpresa) => api.post('/produtos/', data, { params: params(idEmpresa) });
export const updateProduto = (id, data, idEmpresa) => api.patch(`/produtos/${id}`, data, { params: params(idEmpresa) });
